import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { PhoneNumberComponent } from 'src/app/shared/phone-number/phone-number.component';
import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { PrimaryCareProvider } from './shared/primary-care-provider.model';
import { PreferredPharmacy } from './shared/preferred-pharmacy.model';


@Component({
  selector: 'provider-and-pharmacy',
  templateUrl: './provider-and-pharmacy.component.html',
})
export class ProviderAndPharmacyComponent {
  @ViewChild('preferredPharmacyPhoneNumber') preferredPharmacyPhoneNumber!: PhoneNumberComponent;

  title = 'providerAndPharmacy.title';
  progressBar = this.progress.providerAndPharmacy;
  primaryCareProvider: PrimaryCareProvider = this.store.state.consent.primaryCareProvider;
  preferredPharmacy: PreferredPharmacy = this.store.state.consent.preferredPharmacy;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  disabled(): boolean {
    return this.preferredPharmacyPhoneNumber.form.valid;
  }

  back() {
    this.router.navigate([this.navigation.providerAndPharmacy.back]);
  }

  next() {
    this.store.state.consent.primaryCareProvider = this.primaryCareProvider;
    this.store.state.consent.preferredPharmacy = this.preferredPharmacy;

    console.log("consent:", this.store.state.consent);

    this.router.navigate([this.navigation.providerAndPharmacy.next]);
  }

}
